module.exports = {
  // default (green), red, yellow, blue
  colorSchema: 'green',
  urlPath: '/app/',
  appClass: 'creacam',
  footer: require('./footer.html'),
  pageTitle: 'CREACAM',
  sideMenu: require('./Sidemenu.js'),
  logo: '/img/logo.png',
  termsUrl: 'https://www.creacam.de/agb',
  privacyUrl: 'https://www.creacam.de/datenschutz',
  defaultView: 'Packages',
  orderStatusCodes: {
		"": "Neuer Auftrag",
		"order_accepted": "Auftrag angenommen",
		"order_declined": "Auftrag abgelehnt",
		"customer_approval_required": "Kundenfreigabe erforderlich",
		"design_rework_required": "Neudesign nötig",
		"production_rework_required": "Neufertigung nötig",
		"customer_approved": "Design vom Kunden freigegeben",
		"customer_rejected": "Design vom Kunden abgelehnt",
		"paused": "Pausiert",
		"in_design": "Im Design",
		"design_approved": "Vom Design freigegeben",
		"in_production": "In Produktion",
		"qc": "Endkontrolle",
		"ready": "Versandbereit",
		"shipped": "Versendet"
  },
  workflowTypes: {
    Addons: require('./Addons/Addons.js'),
    Annex: require('./Annex/Annex.js'),
    Production: require('./Production/Production.js'),
    DesignProduction: require('./DesignProduction/DesignProduction.js'),
    Design: require('./Design/Design.js'),
    DesignProductionApproval: require('./DesignProduction/DesignProductionApproval.js'),
    Approval: require('./Approval/Approval.js')
  },
  projectDialogForm: [{
    id: 'xmlNumber',
    type: 'text',
    label: {
      de: 'XML-Nummer',
      en: 'XML Number'
    }
  }],
  projectColumns: [
    'mixed',
    'creationdate',
    'lastmodified',
    'workflow',
    'status'
  ],
  orderColumns: [
    'transactionnum',
    'reference',
    'workflow',
    'date',
    'duedate',
    'status',
  ],
  loginOutro: {
    de: '<b>Kein Zugang?</b> <a href="https://creacam.dentadesk.com/register/">Hier können Sie sich registrieren!</a><br/><b>Passwort vergessen?</b> <a href="/app/login/reset">Hier können Sie Ihr Passwort zurücksetzen!</a>',
    en: '<b>No account?</b> <a href="https://creacam.dentadesk.com/register/">You can register here!</a><br/><b>Forgot your password?</b> <a href="/app/login/reset">Reset your password here!</a>'
  },
  hideInvoiceStatus: true,
  locales: {
    en: {
      CookieConsent: {
        message: 'This website uses cookies to ensure you get the best possible experience on our website. Intergrated third-party services may consolidate this information with further data. Cookies may contain personal data unless explicitly specified otherwise. By clicking "Select all and close", you agree to the use of these cookies and save your settings for the specified storage period. Alternatively, you can select which specific cookies you\'d like to enable and save your settings by clicking "confirm selection". You can find further information as well as the possibility of regulatory objections in our <a href="https://www.creacam.de/datenschutz">Privacy Policy</a>.',
      }
    },
    de: {
      CookieConsent: {
        message: 'Diese Website verwendet Cookies, um Ihnen die bestmögliche Erfahrung zu gewährleisten. Integrierte Drittanbieter können diese Informationen mit weiteren Daten zusammenführen. Sofern nicht anders angegeben, enthalten die Cookies personenbezogene Daten. Durch Klicken auf "Alle wählen und schließen" erklären Sie sich mit der Verwendung dieser Cookies einverstanden und speichern Ihre Einstellungen. Alternativ können Sie auswählen, welche spezifischen Cookies Sie zulassen möchten und Ihre Einstellungen durch Klicken auf "Auswahl bestätigen" speichern. Weitere Informationen sowie die Widerspruchsmöglichkeit finden Sie in unseren <a href="https://www.creacam.de/datenschutz">Datenschutzhinweisen</a>.',
      },
      Configurator: {
        oneUnit: '1 Einheit',
      }
    }
  },
  deleteProjectConfirmation: {
    text: {
      en: 'Do you really want to remove this project?',
      de: 'Möchten Sie wirklich dieses Projekt entfernen?'
    }
  },
  features: {
    legacyGoToCart: true,
    reorder: true
  },
  locales: {
    de: require('./Locale/de.js'),
    en: require('./Locale/en.js')
  }
}
